import { jsx } from 'react/jsx-runtime';

const SearchForm = (props) => jsx("form", { ...props, role: "search" });

export { SearchForm };
